import pixelsart from '../images/pixelsart.jpeg';
import todolist from '../images/todolist.jpeg';
import trybewarts from '../images/trybewarts.jpeg';
import solar from '../images/solarsystem.png';
import miusic from '../images/music.jpeg';
import trybewallet from '../images/trybewallet.jpeg';
import cookit from '../images/cookit.jpeg';

export const dataFrontEnd = [
  {
    name: 'Cookit',
    image: cookit,
    url: "https://cookit-app-de-receitas.vercel.app/#/",
    github:"https://github.com/anaualima/cookit-app-de-receitas",
    description: 'Este projeto foi elaborado em grupo (Alissandra Lima, Bruno Melo, Danielle Silva e Lucca Neiva), a proposta é um aplicativo de receitas pelo qual foi necessário o consumo de duas APIs, uma de comida e outra de bebidas. Cookit conta com vídeo, busca por ingrediente, e muitas facilidades na hora de cozinhar aquele prato maravilhoso.',
  },
  {
    name: 'Trybewallet',
    image: trybewallet,
    url: "https://trybe-wallet-omega.vercel.app/",
    github: "https://github.com/anaualima/TrybeWallet",
    description: 'O trybe wallet funciona como uma espécie de carteira virtual, que a pessoa usuária poderá levar para uma viagem internacional sem problemas, pois é disponível o serviço de cambio de moedas, além da soma final dos valores, e ainda um bloco de anotações.',
  },
  {
    name: 'Miu-sic',
    image: miusic,
    url: "https://miu-sic-trybe.vercel.app/",
    github: "https://github.com/anaualima/miu-sic-trybe",
    description: 'Aplicação que renderiza músicas na tela através de uma pesquisa feita pela pessoa usuária.',
  },
  {
    name: 'TrybeWarts',
    image: trybewarts,
    url: "https://trybewarts-chi.vercel.app/",
    github: "https://github.com/anaualima/trybewarts",
    description: 'Um breve estudo que fiz com a colega Millene Galleti com uso de flexbox.',
  },
  {
    name: 'Solar System',
    image: solar,
    url: "https://solar-system-swart.vercel.app/",
    github: "https://github.com/anaualima/solar-system",
    description: 'Este projeto foi meu primeiro contato com react teve como objetivo a organização de classes, bem como alguns conceitos de CSS treinando flexbox.',
  },
  {
    name: 'To do List',
    image: todolist,
    url: "https://to-do-list-trybe.vercel.app/",
    github: "https://github.com/anaualima/to-do-list-trybe",
    description: 'Este projeto foi meu primeiro contato com react teve como objetivo a organização de classes, bem como alguns conceitos de CSS treinando flexbox.',
  },
  {
    name: 'Pixels-Art',
    image: pixelsart,
    url: "https://pixels-art-trybe.vercel.app/",
    github:"https://github.com/anaualima/pixels-art-trybe",
    description: 'O projeto pixelsart é um jogo que proporciona a pessoa usuária a possibilidade de pintar os pixels com as cores pirmárias, criando assim lindas artes, vem soltar sua criatividade!',
  }
];